import { Heading, SimpleGrid, Stack, Text } from "@chakra-ui/react";
import React from "react";

export default function AnalyticsCards() {
  return (
    <Stack gap={2}>
      <Heading fontSize={{ base: "18px", lg: "24px" }} fontWeight={"semibold"}>
        Analytics
      </Heading>
      <SimpleGrid columns={{ base: 2, xl: 4, "2xl": 1 }} gap={2}>
        {data.map((item) => {
          return (
            <Card label={item.label} key={item.label} amount={item.amount} />
          );
        })}
      </SimpleGrid>
    </Stack>
  );
}

const Card = ({ label, amount }) => {
  return (
    <Stack bg="#008DDB36" alignItems={"center"} py={5}>
      <Text fontSize={{ base: "12px", lg: "18px" }} fontWeight={"medium"}>
        {label}
      </Text>
      <Text fontSize={{ base: "14px", lg: "25px" }} color="rgba(0,0,0,0.42)">
        $ {amount}
      </Text>
    </Stack>
  );
};

const data = [
  {
    label: "Sales",
    amount: 0,
  },
  {
    label: "Sales in July",
    amount: 0,
  },
  {
    label: "Avg Selling Price",
    amount: 0,
  },
  {
    label: "Order Completed",
    amount: 0,
  },
];
